module.exports = __webpack_public_path__ + "img/project-bg-1.e79a8e71.png";